import Vue from 'vue';

export const BUS_EVENTS = {
  connectionUpdate: 'connectionUpdate',
  listenChat: 'listenChat',
  clientTriggerSendChat: 'clientTriggerSendChat',
  initAchaChatbotSession: 'initAchaChatbotSession',
  initChangePhoneNumberChatSession: 'initChangePhoneNumberChatSession', // init chat session with the CS Agent to handle the change phone number complaint
  initGptEscalationToAchaChatbot: 'initGptEscalationToAchaChatbot',
  initGptEscalationToTier1CsAgent: 'initGptEscalationToTier1CsAgent',
  clientTriggerHubungkanDenganCS: 'clientTriggerHubungkanDenganCS',
  initPlatinumOrWhitelistedEscalationToTier1CsAgent: 'initPlatinumOrWhitelistedEscalationToTier1CsAgent', // redirect platinum or whitelisted user to CS Agent
};

const messageListEventBus = new Vue();

export default messageListEventBus;
